import { Component, Input, Output, EventEmitter, forwardRef, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true
    }
  ]
})
export class SliderComponent implements OnInit, ControlValueAccessor {
  @Input() min: number = 1;
  @Input() max: number = 5;
  @Input() step: number = 1;
  @Input() disabled: boolean = false;
  @Input() showTooltip: boolean = true;
  @Output() valueChange = new EventEmitter<number>();
  @ViewChild('nouislider', { static: false }) nouislider: any;

  value: number = 1;
  sliderConfig: any = {};

  private _min: number = 1;
  private _max: number = 5;
  private onChange = (value: number) => { };
  private onTouched = () => { };

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this._min = this.min;
    this._max = this.max;
    this.value = this.value || this.min;
    this.updateSliderConfig();
  }

  private updateSliderConfig() {
    this.sliderConfig = {
      start: [this.value],
      connect: [true, false],
      range: {
        'min': this._min,
        'max': this._max
      },
      step: this.step,
      tooltips: [false]
    };
  }

  onSliderChange(event: any) {
    const newValue = typeof event === 'number' ? event : (event && event.length > 0 ? event[0] : this.value);
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();

    // Emitir evento customizado
    this.valueChange.emit(newValue);

    this.cdr.detectChanges();
  }

  onSliderSlide(event: any) {
    const newValue = typeof event === 'number' ? event : (event && event.length > 0 ? event[0] : this.value);
    this.value = newValue;
    this.cdr.detectChanges();
  }

  onSliderSet(event: any) {
    const newValue = typeof event === 'number' ? event : (event && event.length > 0 ? event[0] : this.value);
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();

    // Emitir evento customizado
    this.valueChange.emit(newValue);

    this.cdr.detectChanges();
  }

  // ControlValueAccessor implementation
  writeValue(value: number): void {
    this.value = value || this.min;
    if (this.sliderConfig) {
      this.sliderConfig.start = [this.value];
    }

    // Forçar atualização visual do slider se ele já foi inicializado
    setTimeout(() => {
      if (this.nouislider && this.nouislider.slider) {
        this.nouislider.slider.set([this.value]);
      }
    }, 0);

    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
